/* VIECLAT fixes: require an explicit size choice before add to cart */
(() => {
  const picked = new Set();
  const startedWithVariant = new URL(window.location.href).searchParams.has('variant');
  const PLACEHOLDER = 'Select a size';
  const ERROR = 'Please select a size';

  function info(trigger) {
    const modal = document.getElementById(trigger.getAttribute('aria-controls') || '');
    const input = modal && modal.querySelector('input[type="radio"]');
    if (!input) return null;
    return { modal, formId: input.getAttribute('form'), param: input.name };
  }

  function needs(trigger) {
    const i = info(trigger);
    return !!i && !startedWithVariant && !picked.has(i.formId);
  }

  function setText(el, txt) {
    if (el && el.textContent !== txt) el.textContent = txt;
  }

  function clearError(trigger) {
    const err = trigger.parentElement && trigger.parentElement.querySelector('.vsg-size-error');
    if (err) err.remove();
  }

  function paint() {
    document.querySelectorAll('.size-select-trigger').forEach((t) => {
      if (needs(t)) {
        setText(t.querySelector('span'), PLACEHOLDER);
        if (!t.classList.contains('size-select-trigger--empty')) t.classList.add('size-select-trigger--empty');
      } else if (t.classList.contains('size-select-trigger--empty')) {
        t.classList.remove('size-select-trigger--empty');
        clearError(t);
      }
    });
  }

  function markPicked(input, alreadyChecked) {
    document.querySelectorAll('.size-select-trigger').forEach((t) => {
      const i = info(t);
      if (!i || input.name !== i.param) return;
      picked.add(i.formId);
      const lbl = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
      if (lbl) setText(t.querySelector('span'), lbl.textContent.trim());
      t.classList.remove('size-select-trigger--empty');
      clearError(t);
      if (alreadyChecked && i.modal && typeof i.modal.hide === 'function') {
        setTimeout(() => i.modal.hide(), 50);
      }
    });
  }

  function prompt(trigger) {
    let err = trigger.parentElement.querySelector('.vsg-size-error');
    if (!err) {
      err = document.createElement('p');
      err.className = 'vsg-size-error text-sm';
      err.setAttribute('role', 'alert');
      err.textContent = ERROR;
      trigger.insertAdjacentElement('afterend', err);
    }
    trigger.scrollIntoView({ block: 'center', behavior: 'smooth' });
    setTimeout(() => trigger.click(), 250);
  }

  function gate(formId, e) {
    if (!formId) return;
    const triggers = Array.from(document.querySelectorAll('.size-select-trigger'));
    const t = triggers.find((tr) => {
      const i = info(tr);
      return i && i.formId === formId;
    });
    if (t && needs(t)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      prompt(t);
    }
  }

  document.addEventListener('change', (e) => {
    const input = e.target;
    if (input instanceof HTMLInputElement && input.type === 'radio') markPicked(input, false);
  }, true);

  document.addEventListener('click', (e) => {
    const target = e.target instanceof Element ? e.target : null;
    if (!target) return;

    const lbl = target.closest('label[for]');
    if (lbl) {
      const input = document.getElementById(lbl.htmlFor);
      if (input instanceof HTMLInputElement && input.type === 'radio' && input.checked) markPicked(input, true);
    }

    const btn = target.closest('button[type="submit"], .shopify-payment-button');
    if (btn) {
      const form = btn.getAttribute('form') || (btn.closest('form') && btn.closest('form').getAttribute('id'));
      gate(form, e);
    }
  }, true);

  document.addEventListener('submit', (e) => {
    const f = e.target;
    const fid = f && f.getAttribute && f.getAttribute('id');
    if (fid) gate(fid, e);
  }, true);

  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; paint(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  paint();
})();